import { render } from "./px-icon.vue?vue&type=template&id=f133046c&scoped=true&ts=true"
import script from "./px-icon.vue?vue&type=script&lang=ts"
export * from "./px-icon.vue?vue&type=script&lang=ts"

import "./px-icon.vue?vue&type=style&index=0&id=f133046c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f133046c"]])

export default __exports__